import { Permission } from "Permission/Domain/Model/Permission";

export class PermissionGroup {
    constructor(
      id,
      sku,
      description,
      permissions,
      deletedAt,
    ) {
        this.id = id;
        this.sku = sku;
        this.description = description;
        this.permissions = permissions;
        this.deletedAt = deletedAt;
    }
    static createFromResponseData(data) {
      return new PermissionGroup(
        data.id,
        data.sku,
        data.description,
        data.permissions.map(permission => Permission.createFromResponseData(permission)),
        data.deletedAt,
      );
    }
  };